//react
import React, { Component } from 'react';
import { Link } from 'react-router-dom';

//components
import NavCulture from '../navCulture/navCulture';

//data
import dataSiteMap from '../../siteMap.json';

//assets
import './header.css';
import imgLogo from './nyxoid-logo.png';
import imgLogoContentPage from './nyxoid-logo-content-page.png';

class Header extends Component {
	navCulture() {
		if (this.props.culture) {
			return (
				<NavCulture contentPage={this.props.contentPage} pageNotFound={this.props.pageNotFound} culture={this.props.culture} />
			);
		}

		return null;
	}

	render() {
		const culture = this.props.culture;
		let headerClass = 'header';
		let logoSource = imgLogo;
		let homeLink = '/';
		let homeLinkLang = 'en';

		if (this.props.contentPage) {
			headerClass += ' header--content-page';
			logoSource = imgLogoContentPage
		}

		if (culture && culture !== 'global') {
			homeLink += culture;

			if (dataSiteMap[culture]) {
				homeLinkLang = dataSiteMap[culture].cultureCode;
			}
		}

		const logo = () => {
			if (this.props.contentPage) {
				return (
					<Link className="header__link hwa" hrefLang={homeLinkLang} to={homeLink}>
						<img alt="Nyxoid logo" className="header__logo" src={logoSource} />
					</Link>
				);
			}

			return <img alt="Nyxoid logo" className="header__logo" src={logoSource} />
		}

		return (
			<header className={headerClass}>
				<div className="container">
					<div className="container__row container__row--small">
						<div className="container__column">
							{logo()}
						</div>
						<div className="container__column">
							{this.navCulture()}
						</div>
					</div>
				</div>
			</header>
		);
	}
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/header/header.js